import {BaseEntityUnDeletable} from '../../../common/entities';

export class ExitReason extends BaseEntityUnDeletable {
    description: string;
}
